/**
 * CSP Violation Reporting for DataPro Web application
 * Monitors and reports Content Security Policy violations
 */

export interface CSPViolation {
  documentURI: string;
  violatedDirective: string;
  blockedURI: string;
  effectiveDirective: string;
  sourceFile: string;
  lineNumber: number;
  originalPolicy: string;
}

/**
 * Initializes CSP violation reporting
 * Listens for securitypolicyviolation events and handles them appropriately
 */
export const initCSPReporting = (): void => {
  document.addEventListener('securitypolicyviolation', (event) => {
    const violation: CSPViolation = {
      documentURI: event.documentURI,
      violatedDirective: event.violatedDirective,
      blockedURI: event.blockedURI,
      effectiveDirective: event.effectiveDirective,
      sourceFile: event.sourceFile,
      lineNumber: event.lineNumber,
      originalPolicy: event.originalPolicy,
    };

    // Log violations in development mode
    if (process.env.NODE_ENV === 'development') {
      console.warn('CSP Violation:', violation);
    }

    // In production, you could send violations to a monitoring service
    // Example: sendViolationToMonitoring(violation);
  });
};

/**
 * Example function for sending violations to a monitoring service
 * Uncomment and implement based on your monitoring solution
 */
/*
const sendViolationToMonitoring = (violation: CSPViolation): void => {
  // Example implementation for sending to monitoring service
  fetch('/api/csp-violations', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(violation),
  }).catch(error => {
    console.error('Failed to report CSP violation:', error);
  });
};
*/
